export const FETCH_PARKING_CHARGES_BY_PERMIT_TYPE_REQUEST = 'FETCH_PARKING_CHARGES_BY_PERMIT_TYPE_REQUEST';
export const FETCH_PARKING_CHARGES_BY_PERMIT_TYPE_SUCCESS = 'FETCH_PARKING_CHARGES_BY_PERMIT_TYPE_SUCCESS';
export const FETCH_PARKING_CHARGES_BY_PERMIT_TYPE_FAILURE = 'FETCH_PARKING_CHARGES_BY_PERMIT_TYPE_FAILURE';

